import React, { useContext, useEffect } from "react";
import { motion } from "framer-motion";
import { colourThemes } from "../../styles/colourPalettes";
import style from "./ColourPicker.module.css";
import ColourContext from "../../contexts/ColourContext";
import Container from "../../hoc/container/Container";
import { setDataInLocalStorage } from "../../utils/storage";

// type ColourPickerProps = {
//   activeKey: string;
//   colourPressed: (string) => void;
// };

const ColourPicker = () => {
  const { key: colourKey, set: setColourKey } = useContext(ColourContext);

  const handleClick = (key: string) => {
    setColourKey(key);
    setDataInLocalStorage("colourKey", key);
  };

  return (
    <Container containerClass={style.container}>
      {Object.keys(colourThemes).map((key, i) => (
        <motion.div
          key={i}
          role="button"
          className={style.button}
          onClick={() => handleClick(key)}
          style={{
            backgroundColor: colourThemes[key],
          }}
          animate={{
            scale: colourKey === key ? 1.2 : 1,
            opacity: colourKey === key ? 1 : 0.4,
            borderColor:
              colourKey === key ? "rgba(255,255,255,1)" : "rgba(255,255,255,0)",
          }}
        />
      ))}
    </Container>
  );
};

export default ColourPicker;

/* <div
            style={{
              opacity: colourKey === key ? 1 : 0,
              backgroundColor: colourThemes[key],
              background: `radial-gradient(circle at center, ${colourThemes[key]} 0%, rgba(255,255,255,0) 50%)`,
              transform: `scale(${colourKey === key ? 2 : 1})`,
            }}
          /> */
